<!--单位信息模块,暂时隐藏了右边部分，需要重新设计-->
<template>
  <div class="topLeftTitleContent2">

    <div class="titled"> <img class="img" src="@/assets/kanban/11.png" />电能统计（单位：KWH）
      <span class="iconed" @click="flagFn">
        <img src="@/assets/kanban/Frame10.png" style="margin-right: 10px;" />
        <img src="@/assets/kanban/Union.png" />
      </span>
    </div>

    <div class="userPowerContent bodyBorder" style="border: none;">
      <div class="left">
        <div class="barChart">
          <vchart ref='vchartBar'></vchart>
        </div>
      </div>
      <div class="right">
        <div class="monthPowerTop">
          <vchart ref='vchartBarTop1'></vchart>
        </div>

      </div>
    </div>
    <div class="dialoged" v-if="flag">
      <span class="dialoged_box">
        <span class="dialoged_tit">负荷设备信息</span>
        <div>
          <span>配电房数量: </span>
          <span class="p">0</span>
        </div>
        <div>
          <span>负荷设备数: </span>
          <span class="p">10</span>
        </div>
        <div>
          <span>日最大需量: </span>
          <span class="p">125068.6kW</span>
        </div>
        <div>
          <span>月最大需量: </span>
          <span class="p">34606.7kW</span>
        </div>
        <div>
          <span>负荷总容量: </span>
          <span class="p">76469kVA</span>
        </div>
      </span>
    </div>
  </div>
</template>
<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  import vchart from '@/components/module/chart/vchart.vue'
  import powerValueView from '@/page/projectDingZhi/fangzheng/powerValueView.vue'
  import {getClassPGByMonthForHuaPu} from "../../../api/abbNewApi"
  import request from "@/api/http.js";
  export default {
    components: {
      vchart,
      powerValueView,
    },
    data () {
      return {
        yearPowerValue: undefined,
        day1: undefined, //今日
        day2: undefined, //上月同期
        day3: undefined, //昨日同期
        month1: undefined,
        month2: undefined,
        month3: undefined, //去年同期
        monthEvent: 0,
        flag: false,
        setIntervalFn: null,
        options: [{
          value: '1',
          label: '水'
        },{
          value: '2',
          label: '电'
        }],
        value: '2',
        barOption: {"xAxis": [{"type": "category","data": ["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31"],"axisLabel": {"textStyle": {"color": "#ffffff"}},"splitLine": {"lineStyle": {"type": "dashed","color": "#6f7284"}}}],"yAxis": [{"title": "能耗值（KWH）","type": "value","axisLabel": {"textStyle": {"color": "#ffffff"}},"splitLine": {"lineStyle": {"type": "dashed","color": "#6f7284"}}}],"legend": {"x": "left","y": "top","padding": [0,0,0,50],"bottom": "5px"},"backgroundColor": "","tooltip": {"trigger": "axis","confine": true,"axisPointer": {"animation": false}},"grid": {"height": "80%","left": "1%","right": "0","bottom": "0%","top": "20%","containLabel": true},"series": [{"name": "电量","type": "bar","itemStyle": {"normal": {"color": {"x": 0,"y": 0,"x2": 0,"y2": 1,"type": "linear","global": false,"colorStops": [{"offset": 0,"color": "#005ae1"},{"offset": 1,"color": "#34abff"}]}},"emphasis": {"color": {"x": 0,"y": 0,"x2": 0,"y2": 1,"type": "linear","global": false,"colorStops": [{"offset": 0,"color": "#00c6ff"},{"offset": 1,"color": "#34abff"}]}}},"data": [144119.25,242467,303638.5,316889,324450.5,381078.25,404102.75,402451.25,409234.75,585229.5,480409,469210.5,482111.5,472901,471480.5,477877.5,482822.25,469520.5,463377.75,485755.25,490090.75,500436,504218,504919.5,499193.25,508785.25,373952.13]},{"name": "电费","type": "bar","itemStyle": {"normal": {"color": {"x": 0,"y": 0,"x2": 0,"y2": 1,"type": "linear","global": false,"colorStops": [{"offset": 0,"color": "#ffd200"},{"offset": 1,"color": "#e68b11"}]}},"emphasis": {"color": {"x": 0,"y": 0,"x2": 0,"y2": 1,"type": "linear","global": false,"colorStops": [{"offset": 0,"color": "#ff8400"},{"offset": 1,"color": "#ffd200"}]}}},"data": [69839.6481,172862.1895,201098.3669,206769.1546,215801.0087,256831.0652,268598.5988,265247.5077,272570.2761,489261.4295,322960.796,312155.5397,322672.8127,312317.3626,314949.8272,317658.8957,321572.7379,313251.4776,306890.2174,324692.4653,335350.1552,333771.2446,333924.2399,336497.5177,331332.5727,337627.7866,229057.7785]}]},
        top1BarOption: {
          title: {
            text: '月用电量TOP10排行',
            left: '40%',
            top: '5%',
            textStyle: {
              color: '#FFFFFF',
              align: "center"
            }
          },
          grid: {
            left: '25%',
            right: '10%',
            bottom: '3%',
            top: '20%'
          },
          xAxis: {
            show: false,
            type: 'value',

          },
          yAxis: {
            type: 'category',
            axisLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#007eca'
              },
              fontSize: 11
            },
            data: []
          },
          series: []
        },
        top2BarOption: {
          title: {
            text: '月用电增幅TOP5',
            left: '40%',
            top: '1%',
            textStyle: {
              color: '#FFFFFF',
              align: "center"
            }
          },
          grid: {
            left: '20%',
            right: '4%',
            bottom: '0',
            top: '15%'
          },
          xAxis: {
            show: false,
            type: 'value',

          },
          yAxis: {
            type: 'category',
            axisLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#007eca',

              },
              fontSize: 11
            },
            data: []
          },
          series: []
        },
        powerDateList: {},
        monthPowerIncreaseList: [],
        monthIncreaseList: [],

      }
    },
    beforeDestroy () {
      if(this.setIntervalFn) {
        clearInterval(this.setIntervalFn)
      }
    },
    mounted () {

      this.$refs.vchartBar.setData(this.barOption)

    },

    computed: {
      nowUnit () {
        return this.$store.unitStore.getters.getNowUnit
      },
    },
    watch: {
      powerDateList (nv,ov) {
        if(this.value==1) {//判断水
          this.reloadBarChart2();
          return
        }
        var money=[]
        var power=[]
        if(!isempty(nv)) {
          Object.keys(nv).forEach(key => {
            var pw=nv[key]['总电量']
            var my=nv[key]['总电费']
            if(this.$historyTools.isNull(my)) {
              my=undefined
            }
            if(this.$historyTools.isNull(pw)) {
              pw=undefined
            }
            money.push(my)
            power.push(pw)
          })
        }
        this.barOption.series=[{
          name: '电量',
          type: 'bar',
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,0,0,1,[{
                  offset: 0,
                  color: '#005ae1'
                },
                {
                  offset: 1,
                  color: '#34abff'
                }
              ]
              )
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(
                0,0,0,1,[{
                  offset: 0,
                  color: '#00c6ff'
                },
                {
                  offset: 1,
                  color: '#34abff'
                }
              ]
              )
            }
          },
          data: power
        },{
          name: '电费',
          type: 'bar',
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(
                0,0,0,1,[{
                  offset: 0,
                  color: '#ffd200'
                },
                {
                  offset: 1,
                  color: '#e68b11'
                }
              ]
              )
            },
            emphasis: {
              color: new echarts.graphic.LinearGradient(
                0,0,0,1,[{
                  offset: 0,
                  color: '#ff8400'
                },
                {
                  offset: 1,
                  color: '#ffd200'
                }
              ]
              )
            }
          },
          data: money
        }]
        this.$refs.vchartBar.setData(this.barOption)
      },
      monthPowerIncreaseList (nv,ov) {
        if(!isempty(nv)) {
          var seriesData=[]
          var yData=[]
          nv.forEach(e => {
            yData.push(e.deviceName)
            seriesData.push(e.differenceValue)
          })
          if(yData.length<5) {
            var b=5-yData.length
            for(var i=0;i<b;i++) {
              yData.push(" ")
              seriesData.push('')
            }
          }
          this.top1BarOption.series=[{
            name: '用电量',
            type: 'bar',
            barMaxWidth: '50%',
            itemStyle: {
              color: '#0c9326'
            },
            label: {
              normal: {
                show: true,
                formatter: '{c}KWh',
                color: '#fff',
                position: 'insideLeft',
              },
              fontSize: 10
            },
            data: this.getReverse(seriesData)
          }]
          this.top1BarOption.yAxis.data=this.getReverse(yData)
        } else {
          this.top1BarOption.series=[]
          this.top1BarOption.yAxis.data=[]
        }
        this.$refs.vchartBarTop1.setData(this.top1BarOption,true)
      },
      monthIncreaseList (nv,ov) {
        var seriesData=[]
        var yData=[]
        if(!isempty(nv)) {
          nv.forEach(e => {
            yData.push(e.deviceName)
            if(e.lastMonth!=0&&e.thisMonth-e.lastMonth!=0) {
              seriesData.push(((e.thisMonth-e.lastMonth)/e.lastMonth*100).toFixed(2))
            } else {
              seriesData.push(0)
            }
          })
          if(yData.length<5) {
            var b=5-yData.length
            for(var i=0;i<b;i++) {
              yData.push(' ')
              seriesData.push('')
            }
          }
        }
        this.top2BarOption.series=[{
          name: '用电量增幅',
          type: 'bar',
          barMaxWidth: '50%',
          itemStyle: {
            color: '#eb6716'
          },
          label: {
            normal: {
              show: true,
              formatter: '{c}%',
              color: '#fff',
              position: ['90%','0%'],
            },
            fontSize: 11
          },
          data: this.getReverse(seriesData)
        }]
        this.top2BarOption.yAxis.data=this.getReverse(yData)
        // this.$refs.vchartBarTop2.setData(this.top2BarOption)
      },
      nowUnit (nv,ov) {
        this.powerDate()
        this.monthPowerIncrease()
        this.monthIncrease()
      }
    },
    methods: {
      compareValue (a,b) {
        if(a==0||b==0||a==undefined||b==undefined) {
          return "--"
        }
        return cutDigital((a-b)/b*100)+"%"
      },
      getPowerValue (unitId) {
        if(isempty(unitId)) {
          return
        }
        var now=new Date()
        var nowTime=now.getTime()
        var year=now.getFullYear()
        var month=now.getMonth()
        var day=now.getDate()
        var nowZero=new Date(year,month,day).getTime()
        //获取今年用电量
        console.log(new Date(year,0,1).getTime(),'今年总电耗')
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,0,1).getTime(),nowTime,respon => {
          this.yearPowerValue=Number(respon)
          if(month==0) {
            this.month1=Number(respon)
          }
        })
        //获取今日电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero,nowTime,respon => {
          this.day1=Number(respon)
          if(day==1) {
            this.month1=Number(respon)
          }
        })
        //获取昨日电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,nowZero-24*60*60*1000,nowZero-1,respon => {
          this.day2=Number(respon)
        })
        //获取上个月同一天用电量，直接月份减1如果不存在就是空
        var lastMonthDate=new Date(year,month-1,day)
        //if(lastMonthDate.getMonth() + 1 != 12 && lastMonthDate.getMonth() + 1 != 1) {
        this.$api.powerApi.getUnitUsePowerByDate(unitId,lastMonthDate.getTime(),lastMonthDate.getTime()+24*60*60*
          1000-1,respon => {
            console.log(respon,"上月同期")
            this.day3=Number(respon)
          })
        // } else {
        // 	this.day3 = undefined
        // }
        //获取本月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,month,1).getTime(),nowTime,respon => {
          //console.log(respon,"本月")
          this.month1=Number(respon)
        })
        //获取上月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year,month-1,1).getTime(),new Date(year,month,1)
          .getTime()-
          1,respon => {
            this.month2=Number(respon)
          },repon => {
            this.month2=undefined
          })
        //获取去年同月用电量
        this.$api.powerApi.getUnitUsePowerByDate(unitId,new Date(year-1,month,1).getTime(),new Date(this.getLastDay(
          year-1,month+1)).getTime(),respon => {
            this.month3=Number(respon)
          },respon => {
            this.month3=undefined
          })
      },
      getLastDay (year,month) {
        var new_year=year; //取当前的年份          
        var new_month=month++; //取下一个月的第一天，方便计算（最后一天不固定）          
        if(month>12) {
          new_month-=12; //月份减          
          new_year++; //年份增          
        }
        var new_date=new Date(new_year,new_month,1); //取当年当月中的第一天          
        return year+'-'+new_month+'-'+(new Date(new_date.getTime()-1000*60*60*24)).getDate(); //获取当月最后一天日期          
      },
      flagFn () {
        this.flag=!this.flag;
      },
      valueFn () {
        setTimeout(() => {
          this.$refs.powerValueViewTwo.getPowerValue(this.$store.unitStore.getters.getNowUnit.id);
          this.reloadBarChart2()
          this.powerDate()
        },200);
      },
      // 水量水费数据
      reloadBarChart2 () {
        if(this.value!=1) {//判断水 
          return
        }
        var params={
          timeStamp: new Date().getTime(),
          unitId: this.$store.unitStore.getters.getNowUnit.id,
        }
        request({url: "/cost/findWaterCostFromMonth",method: "get",params}).then(res => {
          var a=[];
          var b=[];
          if(res.code==200) {
            for(const key in res.data) {
              a.push(res.data[key]['总电量'])
              b.push(res.data[key]['总电费'])
            }

            this.barOption.series=[{
              name: '水量',
              type: 'bar',
              data: a,
              itemStyle: {
                color: '#1491ff',
              }
            },{
              name: '水费',
              type: 'bar',
              data: b,
              itemStyle: {
                color: '#fbd549',
              }
            }]
            this.$refs.vchartBar.setData(this.barOption)
          }
        })
      },
      powerDate () {
        //今日电耗
        if(!isempty(this.nowUnit.id)) {
          // this.powerDateList = []
          var id=this.nowUnit.id;
          // console.log("12344");
          // this.$api.powerApi.getClassPGByMonthForHuaPu(new Date().getTime(), this.nowUnit.id, respon => {
          // 	if(id == this.nowUnit.id) { //接口延迟时 只赋值当前的unit结果
          // 		this.powerDateList = respon
          // 	}
          // })
          var d={
            'timeStamp': new Date().getTime(),
            'unitId': this.nowUnit.id
          }
          getClassPGByMonthForHuaPu(d).then(res => {
            if(id==this.nowUnit.id) { //接口延迟时 只赋值当前的unit结果
              this.powerDateList=res.data
              if(res.code!=200) {
                this.powerDate()
              }
            }
          })
        }
      },
      monthPowerIncrease () {
        this.monthPowerIncreaseList=[]
        var dateMonth=new Date().formatByMonth()
        this.$api.powerApi.getPowerDifferenceRanking(this.nowUnit.id,new Date(dateMonth+'/01 00:00:00').getTime(),new Date()
          .getTime(),10,respon => {
            this.monthPowerIncreaseList=respon
          })
      },
      //月用电增幅
      monthIncrease () {
        this.monthIncreaseList=[]
        this.$api.powerApi.getMonthDifferenceRanking(this.nowUnit.id,new Date().getTime(),5,respon => {
          this.monthIncreaseList=respon
        })
      },
      getReverse (data) {
        var dataList=[]
        if(!isempty(data)) {
          var dataLength=data.length-1
          data.forEach(e => {
            dataList[dataLength]=e
            dataLength--
          })
        }
        return dataList

      }

    }
  }
</script>
<style>
  .elSelect input {
    background: right;

    color: #fff;
  }
</style>
<style scoped>
  .dialoged {
    background: url("../../../assets/kanban/Group132.png") no-repeat;
    background-size: 100% 100%;
    width: 307px;
    height: 230px;
    position: absolute;
    top: -188px;
    right: 109px;
  }

  .dialoged .dialoged_box .dialoged_tit {
    font-weight: bold;
    margin-top: 9px;
  }

  .dialoged .dialoged_box .p {
    color: #DF9B36;
    font-family: Microsoft YaHei;
    font-weight: regular;
    font-size: 12px;
    padding-left: 8px;

  }

  .dialoged .dialoged_box {
    font-family: Microsoft YaHei;
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    box-sizing: border-box;
    padding: 6px 0 13px 12px;
  }

  .smallWindow {
    width: calc(50% - 6px);
    height: 270px;
  }

  .topLeftTitleContent2 {
    position: relative;
    border: 4px solid #19485C;
    box-sizing: border-box;
  }

  .topLeftTitleContent2 .titled .img {
    padding: 6px 4px;
    padding-top: 4px;
  }

  .topLeftTitleContent2 .titled {
    /* background-image: linear-gradient(to top, #31A9DD, #AAE5FF); */
    color: #fff;
    -webkit-background-clip: text;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 16px;
    display: flex;
    align-items: center;
    border-bottom: 2px solid;
    border-image: linear-gradient(-90deg, #31A9DD00 0%, #32AADD 100%) 1;

  }

  .iconed {
    display: inline-block;
    margin-left: auto;
    float: right;
    cursor: pointer;
    padding: 2px;
    font-size: 21px;
  }

  @import url("../../../components/css/usePowerUnit.css");

  .elSelect {
    width: 100px;
  }


  .barChart {
    width: 97%;
    height: 90%;
  }

  .left .active {
    height: 60%;
  }

  .barChart>>>.default-chart {
    height: 100%;
    width: 100%;
  }

  .monthPowerTop>>>.default-chart {
    height: 100%;
    width: 100%;
  }

  .monthPowerGrowTop>>>.default-chart {
    height: 100%;
    width: 100%;
  }

  .powerValueView {
    height: 30%;
    margin-top: 10px;
  }

  .usePowerUnitDiv {
    height: 320px;
    width: 100%;
  }

  .userPowerContent {
    display: flex;
    font-size: 9px;
    display: flex;
    justify-content: space-between;
    height: calc(100% - 31px);
  }

  .left {
    width: 100%;
    height: 100%;
    flex-wrap: wrap;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
  }

  .right {
    display: none;
    width: 37%;
    height: 100%;
  }

  .monthPowerTop {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }

  .monthPowerGrowTop {
    width: 100%;
    height: 50%;
  }
</style>